import axios from 'axios'

const API_URL = 'http://localhost:3005'

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

// Intercepteur : Ajoute le token automatiquement à chaque appel
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    // Si le token est déjà présent, on l'ajoute dans le header Authorization
    config.headers.Authorization = token.startsWith('Bearer')
      ? token
      : `Bearer ${token}`
  }
  return config
})

// Intercepteur : Gère la déconnexion forcée si le token expire (erreur 401)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default apiClient
